// extracted by mini-css-extract-plugin
export default {"wrapper_user_list":"UserInfo_wrapper_user_list__-uW9l"};